var Scrollbar = (function($, document) {
    'use strict';

    function Scrollbar(object) {
        this.$object = $(object);
        this.memory = {};
        this._willBeRestored = false;
        this.ps = null;

        if( ! this.isInit() ) {
            this.initialize();
        }
    }

    Scrollbar.prototype = {
        reInit: function(object) {
            this.$object = $(object);
            this._willBeRestored = true;
            this.initialize();
            this.restoreFromMemory();
        },

        initialize: function() {
            this.$object.data('scrollbar-object', this);

            this.ps = new PerfectScrollbar(this.$object[0], {
                suppressScrollX: true,
                wheelPropagation: true
            });

            // this.$object.perfectScrollbar({
            //     suppressScrollX: true
            // });
        },

        destroy: function() {
            this.ps.destroy();
            this.ps = null;
        },

        update: function() {
            this.ps.update();
        },

        restoreFromMemory: function() {
            this._willBeRestored = false;

            if( $.isEmptyObject(this.memory) ) {
                return;
            }

            this.$object.scrollLeft(this.memory.x);
            this.$object.scrollTop(this.memory.y);
            this.ps.update();
        },

        saveInMemory: function() {
            this.memory = {
                x: this.$object.scrollLeft(),
                y: this.$object.scrollTop()
            };
        },

        willBeRestored: function() {
            return this._willBeRestored;
        },

        isInit: function() {
            return this.$object.data('ps-id') !== undefined;
        }
    };

    var
        cssSelector,
        scrollbars = {};

    $(document).on('ps-scroll-x, ps-scroll-y', function(e) {
        var object = $(e.target).data('scrollbar-object');

        if(object instanceof Scrollbar && ! object.willBeRestored()) {
            object.saveInMemory();
        }
    });

    return {
        setup: function(_cssSelector) {
            cssSelector = _cssSelector;


            scrollbars  = {};

            $(cssSelector).each(function(index) {
                if($(this).hasClass('scrollbar-set'))
                {
                    return;
                }


                var memoryId = $(this).data('scrollbar-memory-id') || index;

                $(this).addClass('scrollbar-set');

                scrollbars[memoryId] = new Scrollbar(this);
            });
        },
        update: function(_cssSelector) {
            var $selectors = $(cssSelector);

            if(_cssSelector) {
                $selectors.add(_cssSelector);
            }

            $selectors.each(function(index) {
                var
                    memoryId = $(this).data('scrollbar-memory-id') || index,
                    object = scrollbars[memoryId];

                if(object instanceof Scrollbar) {
                    object.reInit(this);
                }
                else {
                    scrollbars[memoryId] = new Scrollbar(this);
                }
            });
        },
        destroy: function(_cssSelector) {
            $(_cssSelector).each(function(index) {
                var
                    memoryId = $(this).data('scrollbar-memory-id') || index,
                    object = scrollbars[memoryId];

                if(object instanceof Scrollbar) {
                    object.destroy();
                }
            });
        },
        resize: function(){
            for(var key in scrollbars)
            {
                if (!scrollbars.hasOwnProperty(key))
                {
                    continue;
                }

                scrollbars[key].update();
            }
        }
    };

})(jQuery, document);
